<template>
  <Dashboard :goal-id="goal_id" :key="goal_id" />
  <!--
  <div class="team-goal-page">
    <div class="team-goal-page__main">
      <template v-if="goal_meta.$ready">
      </template>
      <template v-else>
        Loading...
      </template>
    </div>
  </div>
  -->
</template>

<script>
import Dashboard from '@/components/GoalPage/Dashboard'

export default {
  name: "TeamGoalPage",
  computed: {
    goal_id() {
      return this.$route.params.goalId;
    },
    goal_meta() {
      return this.$models.goalMeta.getNode( this.goal_id );
    },
  },
  components: {
    Dashboard,
  }
};
</script>

<style>
</style>
